import Translations from "../utils/translations/translations"

/** A form validation record */
export default class FormValidation {
    /** Regex for a full name */
    public static get fullName() {
        global.executions.addLine({className: "FormValidation",functionName: "[get] fullName",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "[get] fullName"],fileName: "/shared/validation/form-validation.tsx",childLine: 7,line: "        return new FormValidation("});
        return new FormValidation(
            () => /^[A-Za-zÀ-ÿÁ-ÿ'-]+(?:\s[A-Za-zÀ-ÿÁ-ÿ'-]+)+$/g,
            () => Translations.current.translate('validation.fullName')
        )
    }

    public static get email() {
        global.executions.addLine({className: "FormValidation",functionName: "[get] email",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "[get] email"],fileName: "/shared/validation/form-validation.tsx",childLine: 14,line: "        return new FormValidation("});
        return new FormValidation(
            () => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/g,
            () => Translations.current.translate('validation.email')
        )
    }

    public static get lowercase() {
        global.executions.addLine({className: "FormValidation",functionName: "[get] lowercase",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "[get] lowercase"],fileName: "/shared/validation/form-validation.tsx",childLine: 21,line: "        return new FormValidation("});
        return new FormValidation(
            () => /([a-z])/g,
            () => Translations.current.translate('validation.lowercase')
        )
    }

    public static get uppercase() {
        global.executions.addLine({className: "FormValidation",functionName: "[get] uppercase",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "[get] uppercase"],fileName: "/shared/validation/form-validation.tsx",childLine: 28,line: "        return new FormValidation("});
        return new FormValidation(
            () => /([A-Z])/g,
            () => Translations.current.translate('validation.uppercase')
        )
    }

    public static get number() {
        global.executions.addLine({className: "FormValidation",functionName: "[get] number",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "[get] number"],fileName: "/shared/validation/form-validation.tsx",childLine: 35,line: "        return new FormValidation("});
        return new FormValidation(
            () => /([0-9])/g,
            () => Translations.current.translate('validation.number')
        )
    }

    public static get special() {
        global.executions.addLine({className: "FormValidation",functionName: "[get] special",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "[get] special"],fileName: "/shared/validation/form-validation.tsx",childLine: 42,line: "        return new FormValidation("});
        return new FormValidation(
            () => /[!@#$%^&*()_+={}\[\]:;"'<>,.?\/\\|~-]/g,
            () => Translations.current.translate('validation.special')
        )
    }

    public static get noTrailingSpacesStart() {
        global.executions.addLine({className: "FormValidation",functionName: "[get] noTrailingSpacesStart",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "[get] noTrailingSpacesStart"],fileName: "/shared/validation/form-validation.tsx",childLine: 49,line: "        return new FormValidation("});
        return new FormValidation(
            () => /^(\s|_|-)/g,
            () => Translations.current.translate('validation.noTrailingSpacesStart'),
            true
        )
    }

    public static get noTrailingSpacesEnd() {
        global.executions.addLine({className: "FormValidation",functionName: "[get] noTrailingSpacesEnd",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "[get] noTrailingSpacesEnd"],fileName: "/shared/validation/form-validation.tsx",childLine: 57,line: "        return new FormValidation("});
        return new FormValidation(
            () => /(\s|_|-)$/g,
            () => Translations.current.translate('validation.noTrailingSpacesEnd'),
            true
        )
    }

    public static minLength(minLength: number) {
        if (minLength < 0) throw new Error(`Min length smaller than 0`)
        global.executions.addLine({className: "FormValidation",functionName: "minLength",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "minLength"],fileName: "/shared/validation/form-validation.tsx",childLine: 66,line: "        return new FormValidation("});
        return new FormValidation(
            () => new RegExp(`^(.){${Math.round(minLength)},}$`, 'g'),
            () => Translations.current.translate('validation.minLength', {
                minLength: String(Math.round(minLength)),
                amount: minLength
            })
        )
    }

    public static maxLength(maxLength: number) {
        if (maxLength < 1) throw new Error(`Max length smaller than 1`)
        global.executions.addLine({className: "FormValidation",functionName: "maxLength",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "maxLength"],fileName: "/shared/validation/form-validation.tsx",childLine: 77,line: "        return new FormValidation("});
        return new FormValidation(
            () => new RegExp(`^(.){1,${Math.round(maxLength)}}$`, 'g'),
            () => Translations.current.translate('validation.maxLength', {
                maxLength: String(Math.round(maxLength)),
                amount: maxLength
            })
        )
    }

    public static mustBeChecked() {
        global.executions.addLine({className: "FormValidation",functionName: "mustBeChecked",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "mustBeChecked"],fileName: "/shared/validation/form-validation.tsx",childLine: 87,line: "        return new FormValidation("});
        return new FormValidation(
            () => /^(true)$/g,
            () => Translations.current.translate('validation.mustBeChecked')
        )
    }

    public static mustBeUnchecked() {
        global.executions.addLine({className: "FormValidation",functionName: "mustBeUnchecked",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "mustBeUnchecked"],fileName: "/shared/validation/form-validation.tsx",childLine: 94,line: "        return new FormValidation("});
        return new FormValidation(
            () => /^(false)$/g,
            () => Translations.current.translate('validation.mustBeUnchecked')
        )
    }

    public static get username() {
        global.executions.addLine({className: "FormValidation",functionName: "[get] username",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "[get] username"],fileName: "/shared/validation/form-validation.tsx",childLine: 101,line: "        return new FormValidation("});
        return new FormValidation(
            () => /^([a-zA-Z0-9]|\s|_|-){1,12}$/g,
            () => Translations.current.translate('validation.username')
        )
    }

    /** Gets the pattern */
    public get pattern() {
        global.executions.addLine({className: "FormValidation",functionName: "[get] pattern",hierarchy: ["/shared/validation/form-validation.tsx", "FormValidation", "[get] pattern"],fileName: "/shared/validation/form-validation.tsx",childLine: 109,line: "        return this.patternFactory()"});
        return this.patternFactory()
    }

    constructor(
        private patternFactory: () => RegExp,
        public errorMessage: () => string,
        public inverse = false
    ) {}
}